import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
   :root {
     --bg: ${({ theme }) => theme.background};
     --surface: ${({ theme }) => theme.surface};
     --surface-strong: ${({ theme }) => theme.surfaceStrong};
     --surface-muted: ${({ theme }) => theme.surfaceMuted};
     --nav-surface: ${({ theme }) => theme.navSurface};
     --panel-border: ${({ theme }) => theme.panelBorder};
     --text-primary: ${({ theme }) => theme.color};
     --text-soft: ${({ theme }) => theme.textSoft};
     --accent: ${({ theme }) => theme.accentColor};
     --accent-strong: ${({ theme }) => theme.accentStrong};
     --shadow-color: ${({ theme }) => theme.shadowColor};
  }

   html {
     scroll-behavior: smooth;
   }

   body {
     background:
       radial-gradient(circle at top left, rgba(37, 99, 235, 0.18), transparent 30%),
       radial-gradient(circle at top right, rgba(34, 211, 238, 0.12), transparent 26%),
       linear-gradient(180deg, ${({ theme }) => theme.background}, ${({ theme }) => theme.surfaceMuted});
     color: ${({ theme }) => theme.color};
     transition: background 250ms ease, color 250ms ease;
     min-height: 100vh;
     overflow-x: hidden;
  }

   body::before {
     content: '';
     position: fixed;
     inset: 0;
     pointer-events: none;
     background-image:
       linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
       linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
     background-size: 64px 64px;
     mask-image: radial-gradient(circle at center, black 38%, transparent 90%);
     opacity: ${({ theme }) => (theme.background === '#030712' ? 0.45 : 0.22)};
     z-index: -1;
  }

   a {
     color: inherit;
  }

   ::selection {
     background: ${({ theme }) => theme.accentColor};
     color: ${({ theme }) => theme.background};
  }
`;

export default GlobalStyles;
